import { useState, useEffect } from 'react';
import { customersAPI } from '../../services/api';
import toast from 'react-hot-toast';

export default function CustomerList() {
  const [customers, setCustomers] = useState([]);
  const [meta,      setMeta]      = useState({});
  const [search,    setSearch]    = useState('');
  const [page,      setPage]      = useState(1);
  const [loading,   setLoading]   = useState(false);
  const [showForm,  setShowForm]  = useState(false);
  const [form,      setForm]      = useState({});
  const [editing,   setEditing]   = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const r = await customersAPI.list({ search, page, limit: 20 });
      setCustomers(r.data.data); setMeta(r.data.meta);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [search, page]);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing) await customersAPI.update(editing.id, form);
      else         await customersAPI.create(form);
      toast.success(editing ? 'Cliente atualizado!' : 'Cliente cadastrado!');
      setShowForm(false); setForm({}); setEditing(null); load();
    } catch (err) { toast.error(err.response?.data?.message || 'Erro.'); }
  };

  const startEdit = (c) => { setEditing(c); setForm(c); setShowForm(true); };
  const del = async (id) => {
    if (!window.confirm('Remover cliente?')) return;
    await customersAPI.delete(id).catch(() => {});
    toast.success('Cliente removido.'); load();
  };

  const field = (name, label, type='text', required=false) => (
    <div style={{ marginBottom:12 }}>
      <label style={{ display:'block',fontSize:'.8rem',fontWeight:600,color:'#374151',marginBottom:4 }}>{label}{required&&' *'}</label>
      <input type={type} value={form[name]||''} onChange={e=>setForm(f=>({...f,[name]:e.target.value}))} required={required}
        style={{ width:'100%',padding:'8px 12px',border:'1.5px solid #E5E7EB',borderRadius:8,outline:'none',boxSizing:'border-box' }} />
    </div>
  );

  return (
    <div>
      <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24 }}>
        <h1 style={{ fontSize:'1.5rem',fontWeight:700,color:'#0F172A' }}>Clientes</h1>
        <button onClick={()=>{setShowForm(true);setForm({});setEditing(null)}}
          style={{ background:'#2563EB',color:'#fff',border:'none',borderRadius:8,padding:'10px 20px',fontWeight:600,cursor:'pointer' }}>
          + Novo Cliente
        </button>
      </div>

      <input value={search} onChange={e=>{setSearch(e.target.value);setPage(1)}} placeholder="Buscar por nome, telefone ou e-mail..."
        style={{ width:'100%',padding:'10px 16px',border:'1.5px solid #E5E7EB',borderRadius:8,marginBottom:16,outline:'none',boxSizing:'border-box' }} />

      <div style={{ background:'#fff',borderRadius:12,border:'1px solid #E5E7EB',overflow:'hidden' }}>
        <table style={{ width:'100%',borderCollapse:'collapse' }}>
          <thead><tr style={{ background:'#F8FAFC',borderBottom:'1px solid #E5E7EB' }}>
            {['Nome','Telefone','E-mail','Cidade','Ações'].map(h=>(
              <th key={h} style={{ padding:'12px 16px',textAlign:'left',fontSize:'.8rem',fontWeight:600,color:'#6B7280' }}>{h}</th>
            ))}
          </tr></thead>
          <tbody>
            {loading ? <tr><td colSpan={5} style={{ padding:40,textAlign:'center',color:'#9CA3AF' }}>Carregando...</td></tr>
            : customers.length===0 ? <tr><td colSpan={5} style={{ padding:40,textAlign:'center',color:'#9CA3AF' }}>Nenhum cliente.</td></tr>
            : customers.map(c=>(
              <tr key={c.id} style={{ borderBottom:'1px solid #F1F5F9' }}>
                <td style={{ padding:'12px 16px',fontWeight:600 }}>{c.name}</td>
                <td style={{ padding:'12px 16px',fontSize:'.9rem' }}>{c.phone||'—'}</td>
                <td style={{ padding:'12px 16px',fontSize:'.9rem',color:'#6B7280' }}>{c.email||'—'}</td>
                <td style={{ padding:'12px 16px',fontSize:'.85rem',color:'#6B7280' }}>{c.city||'—'}</td>
                <td style={{ padding:'12px 16px' }}>
                  <button onClick={()=>startEdit(c)} style={{ background:'#EFF6FF',color:'#2563EB',border:'none',borderRadius:6,padding:'4px 12px',cursor:'pointer',marginRight:6,fontSize:'.8rem',fontWeight:600 }}>Editar</button>
                  <button onClick={()=>del(c.id)} style={{ background:'#FEF2F2',color:'#DC2626',border:'none',borderRadius:6,padding:'4px 12px',cursor:'pointer',fontSize:'.8rem',fontWeight:600 }}>Remover</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showForm && (
        <div style={{ position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:100,display:'flex',alignItems:'center',justifyContent:'center',padding:16 }}>
          <div style={{ background:'#fff',borderRadius:16,padding:32,width:'100%',maxWidth:520,maxHeight:'90vh',overflowY:'auto' }}>
            <h3 style={{ fontWeight:700,marginBottom:20 }}>{editing?'Editar':'Novo'} Cliente</h3>
            <form onSubmit={save}>
              {field('name','Nome completo','text',true)}
              <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:12 }}>
                {field('phone','Telefone')} {field('whatsapp','WhatsApp')}
                {field('email','E-mail','email')} {field('cpf_cnpj','CPF/CNPJ')}
                {field('birthdate','Nascimento','date')} {field('city','Cidade')}
              </div>
              {field('address','Endereço')}
              <div style={{ display:'flex',gap:12,justifyContent:'flex-end',marginTop:8 }}>
                <button type="button" onClick={()=>setShowForm(false)} style={{ padding:'10px 20px',border:'1.5px solid #E5E7EB',borderRadius:8,background:'#fff',cursor:'pointer' }}>Cancelar</button>
                <button type="submit" style={{ padding:'10px 24px',background:'#2563EB',color:'#fff',border:'none',borderRadius:8,fontWeight:700,cursor:'pointer' }}>Salvar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
